export default "__VITE_ASSET__17afe77c__"